import PreviewNavPools from "pages/PreviewPage/PreviewNavPools/PreviewNavPools";

export default PreviewNavPools;
